import { StaffDetailsComponent } from "../../common/StaffDetailscomponent";

export const StaffDetail = () => {
  return (
    <>
      <div className="block lg:hidden  bg-SearchBarBackgroundColor ">
        <StaffDetailsComponent />
      </div>
      <div className=" hidden lg:block">
        <div className="bg-gray-300  pb-10">
          <div className=" flex ">
            <div className="pl-8 pt-4 w-full pr-8">
              <StaffDetailsComponent />
            </div>
          </div>
        </div>
      </div>
    
    </>
  );
};
